module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/afd7250deacdec3e3484381b942cc1f0.png";